/* Judge.me loads its button asynchronously. Use the site's existing leading icon. */
(() => {
  const template = document.getElementById('pp-review-action-icon');
  if (!template) return;
  let queued = false;
  const decorate = () => {
    queued = false;
    document.querySelectorAll('[data-testid="write-review-button"], .jdgm-write-rev-link').forEach(button => {
      if (button.querySelector('svg')) return;
      button.prepend(template.content.cloneNode(true));
    });
  };
  new MutationObserver(() => {
    if (!queued) { queued = true; requestAnimationFrame(decorate); }
  }).observe(document.body, {childList: true, subtree: true});
  decorate();
})();
